import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import PageLayout from '../../components/PageLayout.vue';
import AITools from '../../components/AI.vue';
export default {
  __name: 'AIPage',
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(PageLayout, {
        title: "AI工具导航",
        "current-page": "ai"
      }, {
        default: _withCtx(() => [_createVNode(AITools)]),
        _: 1
      });
    };
  }
};